export const getSurroundingData = (componentIdentifier) => (state) =>
  state.configurator.configuration.customdata[componentIdentifier];
